export * from './system-configs/system-config.model';
export * from './config.component';
export * from './config.service';

export * from './system-configs/form-system-config/form-config.component';